module.exports = __webpack_public_path__ + "img/free-planet.4d94056b.svg";